import React from "react";
import MESFMainRouter from "../../routes/MESFMainRouter";

const MESFMainContainer = () => (
	<div id="mainSection" className="container-fluid container-fluid-main">
		<MESFMainRouter />
	</div>
);
export { MESFMainContainer };
